import { IDataToast } from 'components/DataToast';
import { toaster } from 'helpers/toaster';
import { ToastOptions } from 'react-toastify';
import { notifyException } from 'services/appsignal';
import { ESpansException } from 'types/ESpans';
import { TGenericError } from 'types/TGenericError';

export const onErrorHelper = (
  message: string | TGenericError,
  options: ToastOptions<IDataToast> = {}
) => {
  const content = typeof message === 'string' ? message : message?.errors?.at(0) ?? '';
  notifyException(message);
  toaster.error(content, undefined, options);
};

export const onExceptionHelper =
  (message: string, ErrorEnum: ESpansException) => (error: TGenericError) => {
    notifyException(error, ErrorEnum);
    toaster.error(message);
  };

export const onSuccessHelper = (message: string) => () => toaster.success(message);
